/** Runtime brands shared by the public constructors and the hook internals. */
export const flowBrand = Symbol("flow");
export const subflowBrand = Symbol("subflowEntry");
